import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../spartacus/services/user-info.service';

@Component({
  selector: 'app-custom-arr-enrollment-screen',
  standalone: false,
  templateUrl: './custom-arr-enrollment-screen.component.html',
  styleUrls: ['./custom-arr-enrollment-screen.component.scss']
})
export class CustomARREnrollmentScreenComponent {
  constructor(public component: CmsComponentData<CmsBannerComponent>, protected config: OccConfig, private sanitizer: DomSanitizer, private router: Router, public userInfoService: UserInfoService,) { }
  @ViewChild('termsIframe') termsIframe!: ElementRef;
  @ViewChild('termsCheckbox') termsCheckbox!: ElementRef;
  arrData: Observable<any> = this.component.data$;
  pdfUrl: SafeResourceUrl | null = null;
  termsAccepted: boolean = false;
  showError: boolean = false;
  enrollStatus: string = '';
  getPdfUrl(media: any): string {
    return this.config.backend?.occ?.baseUrl + media.url;
  }
  ngOnInit() {
    // if user is enrolled then if we try to navigate autorollover page then it will take me to my-profile page
    this.userInfoService.getAutoRolloverEnrollStatus().subscribe((data:any) => {
      this.enrollStatus=data.enrolledStatus;
      if(this.enrollStatus === 'Enrolled') {
        this.router.navigate(['/my-profile']);
      }
    })
    this.arrData.subscribe(data => {
      if (data?.picture2?.url) {
        const fullUrl = this.getPdfUrl(data.picture2) + '#toolbar=0';
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
      }
    });
  }
  onRolloverClick() {
    // if terms are not accepted then show error message and scroll to the terms checkbox
    if (!this.termsAccepted) {
      this.showError = true;
      const container = this.termsIframe.nativeElement;
      const checkbox = this.termsCheckbox.nativeElement;
      container.scrollTop = checkbox.offsetTop + 30;
      return;
    }
    // if terms are accepeted 
    this.showError = false;
    this.userInfoService.updateAutoRolloverEnrollStatus(true).subscribe({
      next: (response) => {
        // if the user chooses to enroll then for displaying the sucess banner iam setting a flag and then navigating to my-profile page
        this.userInfoService.setAutoRollOverAlert(true);
        this.router.navigate(['/my-profile']);
      },
      error: (error) => {
        console.error('Error updating rollover status:', error);
      }
    });
  }
  // This method is called when the status of terms checkbox is changed(i.e. once user has accepted the terms to remove error msg)
  onTermsChange() {
    if (this.termsAccepted) {
      this.showError = false;
    }
  }
}
